import { SxProps, Theme } from "@/common/styles/style";

export const styles: { [key: string]: SxProps<Theme> } = {
  text: { margin: "5px 10px" },
};
